// Countries and regions the recharge page does not sell to (compliance risk rating "Very High",
// plus Russia and Iraq).
// The country list comes from the API; these ISO 3166-1 alpha-2 codes are removed from it and can
// never be the selected country, so no channel, coin pack or order is requested for them.
export const RESTRICTED_COUNTRY_CODES = Object.freeze([
  'CU', // Cuba
  'IR', // Iran, Islamic Republic of
  'KP', // Korea, Democratic People's Republic of (North)
  'SY', // Syrian Arab Republic
  'MM', // Myanmar
  'KI', // Kiribati
  'PS', // Palestine, State of
  'TV', // Tuvalu
  'EH', // Western Sahara
  'RU', // Russia
  'IQ' // Iraq
])

export function isRestrictedCountry(code) {
  return RESTRICTED_COUNTRY_CODES.includes(String(code || '').trim().toUpperCase())
}
